import { addNotice } from './actions';
import store from 'state/store';

export default {
    addNotice: data => {
        store.dispatch(addNotice(data));
    },
};
